import BaseRepository from './base.repository';

/**
 * Package Repository
 * Handles API communication for package management
 */
class PackageRepository extends BaseRepository {
  constructor() {
    super('packages');
  }

  /**
   * Get all packages with pricing and features
   * @returns {Promise}
   */
  getAllPackages() {
    return this.client.get('');
  }

  /**
   * Get package by ID
   * @param {number} id - Package ID
   * @returns {Promise}
   */
  getPackageById(id) {
    return this.client.get(`/${id}`);
  }

  /**
   * Get package by code (free, plus, pro)
   * @param {string} code - Package code
   * @returns {Promise}
   */
  getPackageByCode(code) {
    return this.client.get(`/code/${code}`);
  }

  /**
   * Check entitlement for a feature (requires authentication)
   * @param {string} featureCode - Feature code
   * @returns {Promise}
   */
  checkEntitlement(featureCode) {
    return this.client.get(`/entitlement/${featureCode}`);
  }
}

export default new PackageRepository();

